import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import {
    useBreakpoint,
    Drawer,
    DrawerProps,
    TextProps,
    Heading,
} from '@landr/maestro';
import { Trans } from '@lingui/macro';
import TextDecorationUnderline from 'components/TextDecorationUnderline/TextDecorationUnderline';

export interface AboutItemProps {
    visible: boolean;
    hide: () => void;
    title: string;
    description: string;
}

const AboutItem: React.FC<AboutItemProps> = ({
    visible,
    hide,
    description,
    title,
}) => {
    const isMobile = useBreakpoint('md');

    const componentsStyles = useMemo(
        () => ({
            slidePanel: isMobile
                ? {
                      side: 'bottom' as DrawerProps['side'],
                      full: true,
                  }
                : {
                      side: 'right' as DrawerProps['side'],
                  },
            text: {
                size: isMobile ? 'lg' : ('xl' as TextProps['size']),
            },
        }),
        [isMobile],
    );

    return (
        <Drawer
            isVisible={visible}
            onClose={hide}
            data-testid="about-item-slide-panel"
            {...componentsStyles.slidePanel}
            height="100%"
            right="0"
        >
            <Drawer.Header>
                <Heading
                    as="h2"
                    color="text.medium"
                    mb="0"
                    textStyle={{ base: 'lg', md: '4xl' }}
                >
                    <Trans>{`About ${title}`}</Trans>
                </Heading>
            </Drawer.Header>
            <Drawer.Content>
                <TextDecorationUnderline {...componentsStyles.text}>
                    <ReactMarkdown
                        children={description}
                        components={{ p: 'span' }}
                    />
                </TextDecorationUnderline>
            </Drawer.Content>
        </Drawer>
    );
};

export default AboutItem;
